import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';
import { setSeparateStay } from '../../../redux/currentSearch/actions';
import { DateUtils } from '../../../utils';
import { getSegments, getSeparateStay } from '../../../redux/currentSearch/selectors';

export const SeparateStayDateRangeMobile = ({ children, segments, separateStay, setSeparateStay }) => {
    const segmentDep = DateUtils.stringToDate(segments[0].date);
    const segmentReturn = DateUtils.stringToDate(segments[1].date);

    const checkInDate = separateStay.checkInDate
        ? DateUtils.stringToDate(separateStay.checkInDate)
        : null;
    const checkOutDate = separateStay.checkOutDate
        ? DateUtils.stringToDate(separateStay.checkOutDate)
        : null;

    const setValue = (date) => {
        const hasCheckIn = !!separateStay.checkInDate;
        const hasCheckOut = !!separateStay.checkOutDate;
        if (hasCheckIn && hasCheckOut) {
            if (DateUtils.compare(date, segmentReturn) <= 0) {
                return;
            }
            setSeparateStay({ ...separateStay, checkInDate: date, checkOutDate: null });
        } else if (hasCheckIn) {
            setSeparateStay({ ...separateStay, checkOutDate: date });
        } else {
            setSeparateStay({ ...separateStay, checkInDate: date, checkOutDate: null });
        }
    };

    return children({
        dates: [checkInDate, checkOutDate],
        minDate: segmentDep,
        maxDate: segmentReturn,
        setValue,
        enabled: separateStay.enabled,
    });
};

SeparateStayDateRangeMobile.propTypes = {
    children: PropTypes.func.isRequired,
    segments: PropTypes.array.isRequired,
    separateStay: PropTypes.shape({
        enabled: PropTypes.bool,
        checkInDate: PropTypes.oneOfType([PropTypes.instanceOf(Date), PropTypes.string]),
        checkOutDate: PropTypes.oneOfType([PropTypes.instanceOf(Date), PropTypes.string]),
    }).isRequired,
    setSeparateStay: PropTypes.func.isRequired,
};

const mapStateToPropsSelector = createStructuredSelector({
    segments: getSegments,
    separateStay: getSeparateStay,
});

export const ConnectedSeparateStayDateRangeMobile = connect(
    mapStateToPropsSelector,
    { setSeparateStay }
)(SeparateStayDateRangeMobile);
